module.exports = "https://r.zoocdn.com/_next/static/images/sold-long@4x-ea81074ed29f37e950432a1d9745e19d.png";